/**
 * Aadhaar number check: exactly 12 digits. There is no checksum (Verhoeff) check —
 * any 12-digit number is accepted as typed or read by OCR.
 */
export class AadharValidator {
  static validate(aadhar: string): boolean {
    return /^\d{12}$/.test(aadhar || '');
  }
}
